import { Plus } from '@phosphor-icons/react';

/**
 * LinksTab — manually add missing affiliate store links + browse shoes without links.
 */
export default function LinksTab({ shoesNoStores, onFetchNoStores, newLink, setNewLink, onAddLink }) {
  return (
    <div className="space-y-6" data-testid="links-tab">
      <div className="border border-[#E4E4E7] bg-white p-6">
        <h3 className="font-heading font-bold text-lg mb-2">Shoes Without Store Links</h3>
        <p className="text-sm text-[#52525B] mb-4">These shoes have no validated store links. Add links manually below.</p>
        {shoesNoStores.length === 0 ? (
          <button onClick={onFetchNoStores} className="bg-[#0A0A0A] text-white font-bold uppercase tracking-wide px-6 py-3 text-xs hover:bg-[#52525B] transition-colors" data-testid="fetch-no-stores-btn">
            Load Shoes Without Stores
          </button>
        ) : (
          <div className="border border-[#E4E4E7] overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="bg-[#F4F4F5] text-xs uppercase text-[#52525B] font-bold">
                <th className="p-3 text-left">Shoe ID</th><th className="p-3 text-left">Brand</th><th className="p-3 text-left">Model</th><th className="p-3 text-left">Category</th><th className="p-3 text-left">Price Range</th>
              </tr></thead>
              <tbody>
                {shoesNoStores.map(s => (
                  <tr key={s.shoe_id} className="border-t border-[#E4E4E7] hover:bg-[#F4F4F5] cursor-pointer" onClick={() => setNewLink(prev => ({ ...prev, shoe_id: s.shoe_id }))}>
                    <td className="p-3 font-mono text-xs">{s.shoe_id}</td>
                    <td className="p-3 font-bold">{s.brand}</td><td className="p-3">{s.model}</td>
                    <td className="p-3 capitalize">{s.category}</td><td className="p-3">${s.price_range}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <div className="border border-[#E4E4E7] bg-white p-6">
        <h3 className="font-heading font-bold text-lg mb-4 flex items-center gap-2"><Plus size={20} /> Add Store Link Manually</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl">
          <div>
            <label className="block text-xs font-bold uppercase tracking-wide text-[#52525B] mb-1">Shoe ID</label>
            <input value={newLink.shoe_id} onChange={e => setNewLink({ ...newLink, shoe_id: e.target.value })}
              className="border-2 border-[#E4E4E7] px-4 py-2 w-full font-mono text-sm focus:border-[#0A0A0A] outline-none" placeholder="e.g. nike-pegasus-41" data-testid="link-shoe-id" />
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-wide text-[#52525B] mb-1">Store Name</label>
            <input value={newLink.store_name} onChange={e => setNewLink({ ...newLink, store_name: e.target.value })}
              className="border-2 border-[#E4E4E7] px-4 py-2 w-full focus:border-[#0A0A0A] outline-none" placeholder="e.g. The Iconic" data-testid="link-store-name" />
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-wide text-[#52525B] mb-1">Region</label>
            <select value={newLink.store_region} onChange={e => setNewLink({ ...newLink, store_region: e.target.value })}
              className="border-2 border-[#E4E4E7] px-4 py-2 w-full focus:border-[#0A0A0A] outline-none" data-testid="link-region">
              <option value="AU">Australia</option><option value="UK">United Kingdom</option><option value="US">United States</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-wide text-[#52525B] mb-1">Currency</label>
            <select value={newLink.currency} onChange={e => setNewLink({ ...newLink, currency: e.target.value })}
              className="border-2 border-[#E4E4E7] px-4 py-2 w-full focus:border-[#0A0A0A] outline-none" data-testid="link-currency">
              <option value="AUD">AUD</option><option value="GBP">GBP</option><option value="USD">USD</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-wide text-[#52525B] mb-1">Price</label>
            <input type="number" value={newLink.price} onChange={e => setNewLink({ ...newLink, price: e.target.value })}
              className="border-2 border-[#E4E4E7] px-4 py-2 w-full focus:border-[#0A0A0A] outline-none" placeholder="149.95" data-testid="link-price" />
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-wide text-[#52525B] mb-1">Product URL</label>
            <input value={newLink.product_url} onChange={e => setNewLink({ ...newLink, product_url: e.target.value })}
              className="border-2 border-[#E4E4E7] px-4 py-2 w-full focus:border-[#0A0A0A] outline-none" placeholder="https://..." data-testid="link-url" />
          </div>
        </div>
        <button onClick={onAddLink}
          className="mt-4 bg-[#FF3B30] text-white font-bold uppercase tracking-wide px-8 py-4 hover:bg-[#D62828] transition-colors flex items-center gap-2"
          data-testid="add-link-btn">
          <Plus size={18} /> Add Store Link
        </button>
      </div>
    </div>
  );
}
